import styled from 'styled-components';

const ModalBody = styled.div`
  flex: 1 1 auto;
  padding: 15px 15px;
`;

export default ModalBody;
